/* eslint-disable consistent-return,import/prefer-default-export */
import store from '../store/index';

export function progressGuard(to, from, next) {
  if (store.state.clients.type !== null) {
    return next();
  }
  return next('/');
}
